import PropTypes from 'prop-types';
import React from 'react';

import { assetUrl } from '../../../../../util/assetUrl';
import DownloadIcon from './IconDwnl';
import GithubIcon from './IconGH';
import QuickstartIcon from './IconQS';
import ReferenceIcon from './IconRef';
import styles from './styles.module.styl';

const Entry = ({
  title,
  name,
  description,
  url: quickstartUrl,
  sdk: { url: sdkUrl, referenceUrl },
  logo,
  defaultArticle: { githubSampleLink } = {},
}) => (
  <li id={name} className={styles.entry}>
    <div className={styles.titleset}>
      <div className={styles.logo}>
        <img src={assetUrl(`/docs/img/platforms/${logo}.svg`)} alt="sdk logo" />
      </div>
      <div className={styles.title}>{title}</div>
    </div>
    <div className={styles.description}>{description}</div>
    <ul className={styles.links}>
      <li>
        <a href={sdkUrl}>
          <GithubIcon />
          <span>Github</span>
        </a>
      </li>
      {githubSampleLink && (
        <li>
          <a href={githubSampleLink}>
            <DownloadIcon />
            <span>Sample App</span>
          </a>
        </li>
      )}
      {quickstartUrl && (
        <li>
          <a href={quickstartUrl}>
            <QuickstartIcon />
            <span> Quickstart</span>
          </a>
        </li>
      )}
      {referenceUrl && (
        <li>
          <a href={referenceUrl}>
            <ReferenceIcon />
            <span> Documentation</span>
          </a>
        </li>
      )}
    </ul>
  </li>
);

Entry.propTypes = {
  title: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  sdk: PropTypes.shape({
    logo: PropTypes.string,
    url: PropTypes.string,
    referenceUrl: PropTypes.string,
  }),
  defaultArticle: PropTypes.shape({
    githubSampleLink: PropTypes.string,
  }),
};

export default Entry;
